import { FunctionComponent } from 'react';

import { Link as RadixLink, LinkProps } from '@radix-ui/themes';

export const Link: FunctionComponent<LinkProps> = (props: LinkProps) => {
  return <RadixLink {...props} />;
};
